import { axiosService } from '..';

export default class GetBusinessPricingMaxLevelService {
    public async execute(): Promise<number | null> {
        return (await axiosService.instance.get('pricings/organization/business-pricing-max-level')).data;
    }
}

export const getBusinessPricingMaxLevelService = new GetBusinessPricingMaxLevelService();
